import { Heading, Text } from '@cleartax/wg-library-typography';
import { trackAction } from '../../../../../../shared';
import { navigationCtx } from '../../../../../../shared/components/layout-components/navigation/context';
import {
  getSectionHTMLById,
  scrollIntoView
} from '../../../../../../shared/components/layout-components/navigation/utils';
import { usePlanCtx } from '../../planDetailsContext';
import { HeroPriceCard } from './hero-price-card';

const HeroFold: React.FC = () => {
  const {
    seoSlug,
    name,
    listingId,
    amountSymbol,
    shortDescription,
    rating,
    approvedReviewCount,
  } = usePlanCtx();
  const { sections } = navigationCtx();
  const reviewSection = getSectionHTMLById(sections, 'review');
  // const planPricingDetails = getPriceDetails(listingId)
  const handleClickViewReviews = () => {
    if (reviewSection) scrollIntoView(reviewSection);
    trackAction('click', '', { label: `view_reviews_${seoSlug}` });
  };
  return (
    <div className="flex  sm:flex-col">
      <div className="w-1/2 sm:w-full">
        <Heading
          type="h1"
          mergeClasses="override"
          className={'text-brand-1000 text-s-44 font-bold sm:text-s-24'}
        >
          {name}
        </Heading>
        <Text type="p" className="text-grey-600 pt-6" weight="medium">
          {shortDescription}
        </Text>
        <div className="flex pt-6 items-center">
          <Text textSize="xl" className="text-brand-1000" weight="bold">
            {rating}
          </Text>
          <Text
            mergeClasses="override"
            className="icon-star-full text-[#FFD240] text-s-18 ml-1 mb-1"
          ></Text>
          <Text
            onClick={() => handleClickViewReviews()}
            className="text-grey-700 pl-4 cursor-pointer hover:underline"
            weight="semibold"
          >
            {`View all reviews (${approvedReviewCount})`}
          </Text>
        </div>
      </div>
      <div className="w-1/2 sm:w-full sm:pt-6">
        <HeroPriceCard
          seoSlug={seoSlug}
          planName={name}
          symbol={amountSymbol}
          listingId={listingId}
        />
      </div>
    </div>
  );
};

export { HeroFold };
